import cx from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';

export interface FooterProps extends ComponentPropsWithoutRef<'footer'> {
  flagsTitle: string;
  flags: Array<Flag>;
  sections: Array<Section>;
  copyRights: string;
}

interface Flag {
  href: string;
  img: string;
  alt: string;
}

interface Section {
  title: string;
  links?: Array<Item>;
}

interface Item {
  title: string;
  href: string;
  tooltip?: string;
}

function Footer({
  flagsTitle,
  flags,
  sections,
  copyRights,
  className,
  ...spreadProps
}: FooterProps) {
  return (
    <footer
      className={cx('wa-footer container-fluid', className)}
      {...spreadProps}
    >
      <div className="container">
        <div className="wa-footer__flags">
          <h6 className="wa-footer__title">{flagsTitle}</h6>
          {flags.map((flag, index) => {
            return (
              <a className="wa-footer__flag" key={index} href={flag.href}>
                <picture>
                  <img
                    alt={flag.alt}
                    src={flag.img}
                    loading="lazy"
                    width={34}
                    height={34}
                  />
                </picture>
              </a>
            );
          })}
        </div>
        <div className="row">
          {sections.map((section, key) => {
            return <FooterSection key={key} section={section} />;
          })}
        </div>
        <div className="row wa-footer__copy-rights">
          <div className="col-sm-12">
            <strong>{copyRights}</strong>
          </div>
        </div>
      </div>
    </footer>
  );
}

interface FooterSectionProps {
  section: Section;
}
function FooterSection({ section }: FooterSectionProps) {
  return (
    <div className="col-md-4">
      <h6 className="wa-footer__title">{section.title}</h6>
      <ul className="wa-footer__list">
        {(section?.links ?? []).map((link, index) => {
          return <SectionItem key={index} item={link} />;
        })}
      </ul>
    </div>
  );
}

interface FooterSectionItemProps {
  item: Item;
}
function SectionItem({ item }: FooterSectionItemProps) {
  const { href, title, tooltip } = item;
  return (
    <li className="wa-footer__list-item">
      <a className="wa-footer__list-link" href={href}>
        {title}
      </a>
      {typeof tooltip === 'string' ? (
        <span
          className="wa-footer-item-tooltip"
          dangerouslySetInnerHTML={{ __html: tooltip }}
        ></span>
      ) : null}
    </li>
  );
}

export default Footer;
